























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import BusinessDescription from '@/components/BusinessDescription/BusinessDescription.vue';
import Table from '@/components/Table/Table.vue';
import RowsTable from '@/components/Table/RowsTable.vue';
import dictionary from './dictionary';
import CheckBox from '@/components/Checkbox/Checkbox.vue';
import AdminService from '@/api/AdminService';
import { IBusinessesSelected } from './CampaignTypes';
import eventBus from '@/utils/eventBus';
@Component({
  components: {
    TextInput,
    SideModalHeader,
    FlexButton,
    BusinessDescription,
    RowsTable,
    Table,
    CheckBox
  },
  $_veeValidate: { validator: 'new' }
})
export default class NewCampaignModal extends Vue {
  service: AdminService = new AdminService();
  dictionary = dictionary;
  state: any = {};
  businessesSelected: IBusinessesSelected = {};
  counter: number = 0;
  formValid: boolean = false;
  rerenderRow: number = 1;
  loading: boolean = true;
  nextLink: string = '';
  debounce = 0;
  noLoadMore: boolean = false;
  showButton: boolean = false;
  @Watch('state', { immediate: true, deep: true })
  changeState() {
    this.validate();
  }

  created() {
    this.state = {
      title: null,
      coinsToBeRewarded: null,
      businessName: null,
      businessList: {
        list: [],
        header: [
          {
            name: '',
            field: 'none'
          }
        ]
      }
    };
    this.loadList();
    this.showButton = false;
  }

  mounted() {
    const container: HTMLElement | null = document.querySelector(
      '.side-modal__content'
    );
    if (container) container.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const element = document.querySelector('.side-modal__content');
    if (element) {
      if (
        element.scrollTop + element.clientHeight + 240 >=
        element.scrollHeight
      ) {
        this.loadList(this.nextLink, 'loadmore');
      }
    }
  }

  loadList(next = '', title = '', filterByTtitle?: boolean) {
    this.state.businessName = title != 'loadmore' && title;

    clearTimeout(this.debounce);
    this.debounce = window.setTimeout(() => {
      if (filterByTtitle) {
        this.noLoadMore = false;
        this.nextLink = '';
      }
      if (this.noLoadMore) return;
      this.loading = true;

      this.service.getBusinessList(next, title).then(res => {
        this.showButton = true;
        this.loading = false;
        if (this.nextLink) {
          this.state.businessList.list = [
            ...this.state.businessList.list,
            ...res.data.items
          ];
        } else {
          this.state.businessList.list = res.data.items;
        }
        // TODO NEXT TO BE FIXED WHEN BACK CHANGE THEIR PAGINATION
        if (res.data.links.next && res.data.links) {
          this.nextLink = res.data.links.next.replace('/search', '');
          this.noLoadMore = false;
        } else {
          this.noLoadMore = true;
        }
      });
    }, 500);
  }

  get getBusinessList() {
    return {
      ...this.state.businessList,
      header: [
        {
          name: this.getPlaceholder(),
          field: 'none'
        }
      ]
    };
  }

  getPlaceholder() {
    return this.counter
      ? `&nbsp;&nbsp;There ${this.counter > 1 ? 'are' : 'is'} ${
          this.counter
        } business selected`
      : '&nbsp;&nbsp;Please select at least one business';
  }

  submit() {
    if (!this.formValid) return;
    const data = {
      name: this.state.title,
      coinsReward: Number(this.state.coinsToBeRewarded),
      businesses: Object.keys(this.businessesSelected)
    };

    this.service.newCampaign(data).then(res => {
      if (res.status === 201) {
        this.$notification('A new campaign has been created');
        eventBus.$emit('setSideModalVisible', false);
        eventBus.$emit('reloadCampaignList');
      }
    });
  }

  validate() {
    this.$validator.validateAll().then(res => {
      const values = Object.values(this.businessesSelected);
      type Reducer = unknown | boolean;

      const reducer: (acc: Reducer, item: Reducer) => Reducer = (
        acc: Reducer,
        item: Reducer
      ) => acc || item;

      const someBusinessSelected = !!values.reduce(reducer, false);
      this.formValid = someBusinessSelected && res;
    });
  }

  toggleBusiness(event: any) {
    if (!this.businessesSelected[event.id]) {
      this.counter++;
      this.businessesSelected[event.id] = true;
    } else {
      delete this.businessesSelected[event.id];
      this.counter--;
    }
    this.state = { ...this.state };
    this.rerenderRow++;
  }
}
